import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/amaze/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const amazeApi = {
  postAmazeCreateUserTag: (data) => {
    return instance().post(`/user-tags`, data)
  }
}

export default amazeApi



// WEBPACK FOOTER //
// ./src/api/amaze.js